import React from "react";
import { ShieldCheck, TrendingUp, Brain, Lock } from "lucide-react";

const STATS = [
  { kpi: "40%", label: "More accurate predictions", icon: Brain },
  { kpi: "50%", label: "Sharper market insights", icon: TrendingUp },
  { kpi: "100%", label: "Real-time market sync", icon: ShieldCheck },
  { kpi: "0$", label: "To start simulating", icon: Lock },
];

const BADGES = [];

const TrustStrip = () => {
  return (
    <section
      data-testid="trust-strip"
      className="relative py-20 md:py-24 border-y border-slate-100 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-slate-500">
            Built on trust
          </span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl font-black tracking-tighter text-slate-900">
            Fintech-grade <span className="brand-gradient-text">numbers.</span>{" "}
            Gen-Z friendly DX.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {STATS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                data-testid={`trust-stat-${s.kpi}`}
                className="rounded-3xl bg-[#FAFAFA] border border-slate-100 p-6 text-center"
              >
                <div className="inline-flex w-11 h-11 rounded-2xl items-center justify-center mb-3 brand-gradient text-white">
                  <Icon size={20} />
                </div>
                <div className="font-display text-4xl font-black brand-gradient-text">
                  {s.kpi}
                </div>
                <div className="mt-1.5 text-xs uppercase tracking-[0.14em] font-bold text-slate-500">
                  {s.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
